exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._24EzJC8rFwyoqG1cenJeZq{text-align:center;font-size:1.1em}._24EzJC8rFwyoqG1cenJeZq h3{margin-top:5px;margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"component": "_24EzJC8rFwyoqG1cenJeZq"
};